import { getJson } from "../../auth/utils/getJson.js";

/** GET /api/filestats/today */
export function fetchTodayFileStats(signal) {
  return getJson("/api/filestats/today", { signal });
}

/** GET /api/operatorfilestats/today */
export function fetchTodayOperatorFileStats(signal) {
  return getJson("/api/operatorfilestats/today", { signal });
}

/** GET /api/filefailures/today */
export function fetchTodayFileFailures(signal) {
  return getJson("/api/filefailures/today", { signal });
}
